:host {
    --wcs-label-font-weight: var(--wcs-semantic-font-weight-book);
    --wcs-label-color: var(--wcs-semantic-color-text-primary);
    --wcs-label-required-marker-color: var(--wcs-semantic-color-text-critical);

    --wcs-label-gap: var(--wcs-semantic-spacing-small);

    font-weight: var(--wcs-label-font-weight);
}

label {
    display: inline-block;
    
    color: var(--wcs-label-color);
    font-weight: var(--wcs-label-font-weight);

    ::slotted(wcs-mat-icon) {
        display: inline-flex;
        vertical-align: text-top;
        margin-left: var(--wcs-label-gap);
    }
}

.required-marker {
    margin-left: 4px;
    vertical-align: text-top;
    color: var(--wcs-label-required-marker-color);
    font-weight: var(--wcs-label-font-weight);
}
